<template>

<div class="tags" :class="{stretch: stretch}">
  <template v-if="!empty">
    <slot />
  </template>
  <template v-else>
    <div class="empty">
      <h2>검출된 결과가 없습니다.</h2>
      <ul>
        <li>- 현재 지원하지 않는 객체일 수 있습니다.</li>
        <li>- 이미지 내 검출 대상이 잘 보이는지 확인해 주세요.</li>
        <li>- 다른 이미지를 선택해 보세요.</li>
        <li>- 검출하려는 대상과 기술이 일치한지 확인해 주세요.</li>
      </ul>
    </div>
  </template>
</div>

</template>

<script>

export default {
  props: {
    stretch: {
      type: Boolean,
      default: false
    },
    empty: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style lang="scss" scoped>
.tags {
  display: flex;
  flex-wrap: wrap;
}

.tags::v-deep(.tag) {
  margin-right: 8px;
  margin-bottom: 8px;
}

.tags.stretch::v-deep(.tag) {
  margin: 0 0 14px 0;
  width: 100%;
  justify-content: center;
}


.empty {
  --empty-title-font-size: 20px;
  --empty-list-font-size: 16px;
  --empty-margin-size: 12px;
  @media screen and (max-width: 940px) {
    --empty-title-font-size: 18px;
    --empty-list-font-size: 14px;
    --empty-margin-size: 8px;
  }
  @media screen and (max-width: 640px) {
    --empty-title-font-size: 16px;
    --empty-list-font-size: 12px;
  }
}

.empty h2 {
  font-weight: 700;
  font-size: var(--empty-title-font-size);
  line-height: 1.4;
  margin: 0 0 var(--empty-margin-size);
  color: var(--gray-900);
  
}

.empty ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.empty ul li { 
  color: var(--gray-700);
  font-size: var(--empty-list-font-size);
  line-height: 1.5;
  font-weight: 400;
}
</style>